// extracted by mini-css-extract-plugin
export default {"category-tag":"styles_category-tag__g67Oq","category-tag--with-emoji":"styles_category-tag--with-emoji__oVXbQ"};